import "./productList.scss";
import emptyStar from "../imgs/emptyStar.svg";
import star from "../imgs/star.svg";
import ProductPrice from "../components/ProductPrice";
const ProductList = () => {
  let reviews = [
    {
      stars: [star, emptyStar, emptyStar, emptyStar, emptyStar],
    },
    {
      stars: [star, star, emptyStar, emptyStar, emptyStar],
    },
    {
      stars: [star, star, star, emptyStar, emptyStar],
    },
    {
      stars: [star, star, star, star, emptyStar],
    },
    {
      stars: [star, star, star, star, star],
    },
  ];
  let computersCat = [
    "Computer Accessories & Peripherals",
    "Computer Components",
    "Computers & Tablets",
    "Data Storage",
    "Laptop Accessories",
    "Monitors",
    "Networking Products",
    "Power Strips & Surge",
    "Protectors",
    "Printers",
    "Scanners",
    "Servers",
    "Tablet Accessories",
    "Tablet Replacement Parts",
    "Warranties & Services",
  ];
  return (
    <div className="productList__wrapper">
      <aside id="filters">
        <ul className="computers__filters">
          <h4 className="p_title">Computers</h4>
          {computersCat.map((item, index) => {
            return (
              <li className="computers__cats__item" key={index}>
                {item}
              </li>
            );
          })}
        </ul>
        <h4 className="p_title">Customer Reviews</h4>
        <ul className="ratings">
          {reviews.map((review, index) => {
            return (
              <li className="reviews" key={index}>
                {review.stars.map((star) => {
                  return <img src={star} alt="stars" />;
                })}
              </li>
            );
          })}
        </ul>
        <h4 className="p_title">Condition</h4>
        <ul>
          <li className="computers__cats__item">New</li>
          <li className="computers__cats__item">Used</li>
          <li className="computers__cats__item">Renewed</li>
        </ul>
      </aside>
      <div className="productList">
        <div className="border"></div>
        <div className="products__wrapper">
          <div className="product__text__wrapper">
            <h1>Computers and IT Accessories</h1>
            <p className="list__text">
              Shop laptops, desktops, monitors, tablets, PC gaming, hard drives
              and storage, accessories and more
            </p>
          </div>
          <div className="productslist__wrapper">
            <div className="productss">
              <ProductPrice
                title="Monitors"
                img="https://m.media-amazon.com/images/I/91qoAzLGPcL._AC_UY327_FMwebp_QL65_.jpg"
                price="500"
                offer="25"
              />
              <ProductPrice
                title="Graphic cards"
                img="https://m.media-amazon.com/images/I/81t7Ga7nyxS._AC_SY200_.jpg"
                price="2000"
                offer="10"
              />
              <ProductPrice
                title="Graphic tablets"
                img="https://m.media-amazon.com/images/I/41pSgmNanZL._AC_SY200_.jpg"
                price="10000"
                offer="15"
              />
            </div>
            <div className="productss">
              <ProductPrice
               title="PC ram"
               img="https://m.media-amazon.com/images/I/61e0Q5nA6PL._AC_SY200_.jpg"
               price="6000"
               offer="10"
              />
              <ProductPrice
                title="RGB lights"
                img="https://m.media-amazon.com/images/I/81DwO7ZZs2L._AC_SY200_.jpg"
                price="2000"
                offer="50"
              />
              <ProductPrice
                title="CPUs"
                img="https://m.media-amazon.com/images/I/51f2hkWjTlL._AC_SY200_.jpg"
                price="12000"
                offer="20"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductList;
